import script from "./ThemeTag.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeTag.vue?vue&type=script&setup=true&lang=js"

import "./ThemeTag.vue?vue&type=style&index=0&id=d3cc32ee&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3cc32ee"]])

export default __exports__